export default {
    props: {
        start: [{
            titleText: 'Чтобы провести корабль по заливу, нужна грамотная навигация.\n' +
                'Капитан вместе с лоцманом задают рулевому курсы и следят за скоростью движения ледокола.\n' +
                'Вместе с лоцманом построй маршрут движения ледокола в лабиринте из торосов в заливе по линии фарватера, избегая препятствий.',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Движемся навстречу препятствию - быть беде... Выбери другую траекторию движения.',
            buttonText: 'Продолжить',
        }],
        end: [{
            titleText: 'Успех.\n' +
                'Все препятствия позади.\n' +
                'Ты молодец!',
            buttonText: 'Продолжить',
        }],
    },
    ropes: {
        start: [{
            titleText: 'Швартовное устройство предназначается для крепления судна при стоянке.\n' +
                'Освободи корабль, чтобы он мог отправиться в плавание.\n' +
                'Отдать береговые швартовные концы необходимо попарно в определенной последовательности, начиная с продольных швартовов.',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Помнишь матрос?\n' +
                'Сначала следует освободить пару продольных (красных) швартовов.',
            
            buttonText: 'Продолжить',
        },
        {
            titleText: 'Подсказка:\n' +
                'Подумай хорошенько!\n' +
                'Какие тросы следует отвязать дальше?',
            buttonText: 'Продолжить',
        },
        {
            titleText: 'Подсказка:\n' +
                'Вслед за продольными швартовыми освободи прижимные (желтые) - тогда все получится верно.',
            buttonText: 'Продолжить',
        },
        ],
        end: [{
            titleText: 'Молодец, матрос! Ты разобрался с хитросплетением крепления судна, теперь мы можем отправляться в плавание.\nВперед!',
            buttonText: 'Продолжить',
        }],
    },
    engine: {
        start: [{
            titleText: 'Приборная панель - мозговой центр ледокола.\n' +
                'Собери схему электро-движения для запуска двигателей.\n' +
                'Выполни действия в нужном порядке, а потом можно нажимать кнопку запуска.',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Так-так, вспоминай, первыми в цепи запуска идут реакторы, начни с них.',
            buttonText: 'Продолжить',
        }, {
            titleText: 'Подсказка:\n' +
                'Не торопись, моряк!\n' +
                'После запуска реакторов идет подключение контуров.',
            buttonText: 'Продолжить',
        }, {
            titleText: 'Подсказка:\n' +
                'Чтобы все работало, выполни следующий шаг - подключение турбин.',
            buttonText: 'Продолжить',
        }, {
            titleText: 'Подсказка:\n' +
                'Так и до поломки оборудования недалеко, моряк.\n' +
                'Будь внимательнее, наше ответственное дело не терпит поспешных решений.',
            buttonText: 'Продолжить',
        }],
        end: [{
            titleText: 'Запуск прошел успешно!\n' +
                'Можно двигаться дальше!',
            buttonText: 'Продолжить',
        }],
    },
    laser: {
        start: [{
            titleText: 'Понаблюдай за устройством лазерной установки.\n' +
                'Нужно направить луч таким образом, чтобы он, отразившись от зеркала, попал в выбранную точку и не задел препятствие.\n' +
                'Выбери подходящее зеркало для каждой точки, чтобы лазер дотянулся до цели на противоположной стороне установки.',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Кажется, луч направлен не в ту сторону, попробуй другую комбинацию.',
            buttonText: 'Продолжить',
        }],
        end: [{
            titleText: 'Лазер работает правильно, ты справился!',
            buttonText: 'Продолжить',
        }],
    },
    fuel: {
        start: [{
            titleText: 'В лаборатории хранятся колбы с реактивами для синтеза эко-топлива.\n' +
                'Получи водород, пригодный для эко-транспорта: для этого необходимо смешать два реактива в большой колбе.\n' +
                'Придется вспомнить химию, матрос!\n' +
                'Удачи!',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Полегче матрос!\n' +
                'Того и гляди, с такой смесью взлетим на воздух!',
            buttonText: 'Продолжить',
        }],
        end: [{
            titleText: 'Ты прирожденный химик! Молодец!',
            buttonText: 'Продолжить',
        }],
    },
    rescue: {
        start: [{
            titleText: 'Команда спасения у цели!\n' +
                'Готовься к маневрам, моряк!\n' +
                'Необходимо контролировать скорость судна, не позволяя ему плыть слишком быстро и не допуская критического замедления.\n' +
                'Следи за шкалой!',
            buttonText: 'Продолжить',
        }],
        hint: [{
            titleText: 'Подсказка:\n' +
                'Моряк, так недолго и до полной остановки!\n' +
                'Не гневи рулевого.',
            buttonText: 'Продолжить',
        }, {
            titleText: 'Подсказка:\n' +
                'Стоп машина!\n' +
                'Слишком высокая скорость, а мы не в гонках тут участвуем.\n' +
                'Давай-ка потише!',
            buttonText: 'Продолжить',
        }],
        end: [{
            titleText: 'Чудеса навигации!\n' +
                'Все получилось в лучшем виде.',
            buttonText: 'Продолжить',
        }],
    },
};
